import React from 'react';

import { TabEmptyState } from './TabEmptyState';

export const PatientDocumentsTab: React.FC = () => {
  return (
    <TabEmptyState
      title="Documents"
      description="The patient's documents will live here."
    />
  );
};
